import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useApp } from "../context/AppContext";
import { OPERATOR_COLORS } from "../assets/logos";
import Card, { SectionLabel } from "../components/ui/Card";
import Button from "../components/ui/Button";
import OperatorSelector from "../components/ui/OperatorSelector";
import { fmt, calcFees, genRef, nowLabel } from "../utils/helpers";

const AMOUNTS = [500, 1000, 2000, 5000];

export default function Credit() {
  const navigate = useNavigate();
  const { setPendingTx } = useApp();

  const [payOp, setPayOp] = useState("o");
  const [recOp, setRecOp] = useState("o");
  const [payPhone, setPayPhone] = useState("");
  const [recPhone, setRecPhone] = useState("");
  const [amount, setAmount] = useState("");
  const [selectedChip, setSelectedChip] = useState(null);

  const col = OPERATOR_COLORS[payOp];

  const handleChip = (val) => {
    setAmount(String(val));
    setSelectedChip(val);
  };

  const handleAmountChange = (e) => {
    setAmount(e.target.value);
    setSelectedChip(null);
  };

  const handlePay = () => {
    const amt = parseFloat(amount) || 1000;
    const fees = calcFees(amt);
    const { date, time } = nowLabel();

    setPendingTx({
      type: "credit",
      payOp,
      recOp,
      payPhone: payPhone || "6XX XXX XXX",
      recPhone: recPhone || "6XX XXX XXX",
      amount: amt,
      fees,
      total: amt + fees,
      ref: genRef(),
      date,
      time,
      label: `Crédit ${OPERATOR_COLORS[recOp].nameShort}`,
      from: "/credit",
    });
    navigate("/confirm");
  };

  return (
    <div className="bg-[#f0f2f7] pb-2 screen-enter">
      {/* Header */}
      <div
        className="px-[17px] pt-[14px] pb-[18px] transition-colors duration-200"
        style={{ background: col.primary }}
      >
        <button
          onClick={() => navigate("/")}
          className="bg-transparent border-none text-white/85 text-xs cursor-pointer p-0 flex items-center gap-1 mb-[9px] font-medium tap-highlight"
        >
          <i className="fa fa-arrow-left" /> Retour
        </button>
        <h2 className="text-white text-[17px] font-bold mb-0.5">Acheter du crédit</h2>
        <p className="text-white/80 text-[11px]">Moyen de paiement + numéro destinataire</p>
      </div>

      <div className="p-3">
        {/* Step 1 : Moyen de paiement */}
        <Card className="mb-[9px]">
          <SectionLabel>1 · Moyen de paiement</SectionLabel>
          <OperatorSelector value={payOp} onChange={setPayOp} />
          <div className="mt-2.5">
            <SectionLabel className="mb-1.5">
              Numéro payeur · {OPERATOR_COLORS[payOp].name}
            </SectionLabel>
            <div className="flex gap-1.5">
              <div
                className="flex items-center px-3 rounded-[9px] text-xs font-bold flex-shrink-0 border"
                style={{
                  background: col.light,
                  color: col.primary,
                  borderColor: col.border,
                }}
              >
                +237
              </div>
              <input
                type="tel"
                placeholder="6XX XXX XXX"
                value={payPhone}
                onChange={(e) => setPayPhone(e.target.value)}
                className="flex-1 border border-gray-200 rounded-[11px] px-3 py-[11px] text-sm text-brand-dark outline-none focus:border-brand-orange transition-colors bg-white"
              />
            </div>
          </div>
        </Card>

        {/* Step 2 : Destinataire */}
        <Card className="mb-[9px]">
          <SectionLabel>2 · Numéro destinataire</SectionLabel>
          <OperatorSelector value={recOp} onChange={setRecOp} labelStyle="short" />
          <div className="mt-2.5">
            <SectionLabel className="mb-1.5">
              Numéro destinataire · {OPERATOR_COLORS[recOp].nameShort}
            </SectionLabel>
            <div className="flex gap-1.5">
              <div className="flex items-center px-3 rounded-[9px] text-xs font-bold flex-shrink-0 bg-gray-100 border border-gray-200 text-gray-600">
                +237
              </div>
              <input
                type="tel"
                placeholder="6XX XXX XXX"
                value={recPhone}
                onChange={(e) => setRecPhone(e.target.value)}
                className="flex-1 border border-gray-200 rounded-[11px] px-3 py-[11px] text-sm text-brand-dark outline-none focus:border-brand-orange transition-colors bg-white"
              />
            </div>
          </div>
        </Card>

        {/* Step 3 : Montant */}
        <Card className="mb-3">
          <SectionLabel>3 · Montant (FCFA)</SectionLabel>
          <div className="grid grid-cols-4 gap-[5px] mb-2">
            {AMOUNTS.map((val) => {
              const sel = selectedChip === val;
              return (
                <button
                  key={val}
                  onClick={() => handleChip(val)}
                  className="cursor-pointer border rounded-[9px] py-2 text-xs font-bold transition-all tap-highlight"
                  style={{
                    borderColor: sel ? "#FF6200" : "#e5e7eb",
                    color: sel ? "#FF6200" : "#374151",
                    background: sel ? "#fff7f0" : "white",
                    borderWidth: sel ? 1.5 : 1.5,
                  }}
                >
                  {val >= 1000 ? `${val / 1000} 000` : val}
                </button>
              );
            })}
          </div>
          <input
            type="number"
            placeholder="Autre montant..."
            value={amount}
            onChange={handleAmountChange}
            className="w-full border border-gray-200 rounded-[11px] px-3 py-[11px] text-sm text-brand-dark outline-none focus:border-brand-orange transition-colors bg-white"
          />
        </Card>

        <Button
          fullWidth
          style={{ background: col.primary }}
          onClick={handlePay}
        >
          Payer maintenant &nbsp;<i className="fa fa-arrow-right" />
        </Button>
      </div>
    </div>
  );
}
